// extracted by mini-css-extract-plugin
export var searchHeader = "_35-0";
export var searchHeaderDark = "_35-1";